import React from "react";
import { NavLink } from "react-router-dom";

// Abas de 2º nível, dentro da Listagem. Uma por rota de consumo do backend:
// cada uma faz UMA requisição, à sua própria rota, e tem estado próprio — falha
// numa não contamina a outra.
//
// Pílulas em vez de abas sublinhadas de propósito: dois níveis de aba com o
// mesmo visual fariam o usuário perder de vista qual é qual.
const SUB_TABS = [
  { to: "/calculator-api", label: "Cálculos", exact: true },
  // rota em inglês de propósito: `/calculator-api/consultas` acendia junto o
  // item `/consultas` do menu lateral, que casa por substring da URL
  { to: "/calculator-api/queries", label: "Consultas" },
];

export default function UsageSubTabs() {
  return (
    <ul className="ca-pills">
      {SUB_TABS.map(tab => (
        <li key={tab.to}>
          <NavLink className="ca-pill" exact={tab.exact} to={tab.to}>
            {tab.label}
          </NavLink>
        </li>
      ))}
    </ul>
  );
}
